var map = {
	"./animal.svg": 40713,
	"./arrow.svg": 10012,
	"./bicycle.svg": 16884,
	"./boat.svg": 90135,
	"./bus.svg": 40493,
	"./car.svg": 35605,
	"./crane.svg": 13600,
	"./default.svg": 22408,
	"./helicopter.svg": 92634,
	"./main-bg.png": 30522,
	"./motorcycle.svg": 92014,
	"./offroad.svg": 22790,
	"./person.svg": 48382,
	"./pickup.svg": 53213,
	"./plane.svg": 54421,
	"./ship.svg": 82431,
	"./tractor.svg": 54242,
	"./train.svg": 19925,
	"./tram.svg": 88237,
	"./trolleybus.svg": 90014,
	"./truck.svg": 55526,
	"./van.svg": 88880
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 14004;